const stripTrailingApiSegment = (value: string) => value.replace(/\/+$/, '').replace(/\/api$/i, '');

const BACKEND_BASE_URL = stripTrailingApiSegment(
  process.env.REACT_APP_BACKEND_URL || process.env.REACT_APP_API_URL || 'http://localhost:5000',
);

export function getPublicPostShareUrl(mediaId: number) {
  return `${BACKEND_BASE_URL}/share/post/${mediaId}`;
}

export function getPublicProfileShareUrl(userId: number) {
  const url = new URL('/content', window.location.origin);
  url.searchParams.set('sharedUserId', String(userId));
  return url.toString();
}

export function getPublicAuditionShareUrl(auditionId: number) {
  const url = new URL('/open-auditions', window.location.origin);
  url.searchParams.set('auditionId', String(auditionId));
  return url.toString();
}

export async function shareLink(url: string, title: string) {
  if (navigator.share) {
    await navigator.share({ title, url });
    return 'shared';
  }

  if (navigator.clipboard?.writeText) {
    await navigator.clipboard.writeText(url);
    return 'copied';
  }

  window.prompt('Copy this link', url);
  return 'prompted';
}
